<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k9RiSa/tc-custom/9781682611173.jpg?1737676323246" alt="This image is the cover for the book Journal: Fault Line, The Journal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journal: Fault Line, The Journal Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Unprepared. Undaunted. The blockbuster post-apocalyptic thriller series continues with the story of an ordinary woman facing an extraordinary disaster. </b><br/><br/>When a seemingly minor tremor escalates into a major earthquake, Christine, the spoiled daughter of John Tiggs, is stranded in the middle of it in St. Louis. Caught at ground zero of the violent catastrophe, Christine must overcome her fears and prejudices to stay alive and find her way home—on her own. And if she ever gets there, she still may not be safe.<br/><br/><b>“Learning from survival fiction is one of my passions although I do recognize and accept that many of the scenarios are quite extreme. Still, as a prepper that is continually challenged by the pursuit of knowledge, I keep reading and keep playing the ‘what if’ game in my own mind. One of the best series of books for doing so is Deborah D. Moore’s The Journal series.” —<i>Backdoor Survival</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah D. Moore
      </h2>
      
      <p class="authorDescription body article">Deborah Moore is single and lives a quiet life in the Upper Peninsula of Michigan with her cat, Tufts.  She was born and raised in Detroit, the kid of a cop, and moved to a small town to raise her two young sons, then moved to an even smaller town to pursue her dreams of being self-sufficient and to explore her love of writing.  Being a lifelong Prepper, Deborah has done numerous articles for magazines, and speaking engagements at conventions regarding the subject. Her first published novel, The Journal: Cracked Earth, made the Bestseller’s list in just six weeks.  Book Two of the series, Ash Fall, went to the printer eight months early because of the unprecedented popularity and Book Three, Crimson Skies, is proving to be even more popular. Raging Tide, the fourth book in the series was to be the final chapter, but Deborah is delighted to announce that book #5 is right around the corner.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b3f58d5a